// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"99f3485d","208":"e4fba3ce","787":"ebafdce5"}[chunkId] + ".chunk.js";
};